import clamp from "../common/helpers/clamp";

class VariantDBDetailsFrequency {
  constructor(data, variant, db) {
    this.mainData = data.main_data;
    this.id = `${db.index}-${variant.id}`;
    this.db = db;
    this.variant = variant;
    this.hidden = false;
    this.freq = VariantDBDetailsFrequency.valToFreqPosition(data.frequency);
  }

  static valToFreqPosition(val) {
    return 1 - Math.log10(clamp(val, 0.000001, 1)) / -6;
  }

  get region() {
    return this.variant.region;
  }
}

export default VariantDBDetailsFrequency;
